export enum JournalStatusEnum {
    Published = 'Published',
    Draft = 'Draft',
  }